import React from 'react'
import Feature from '../Feature/Feature'
import './Whatgt.css'

const Whatgpt = () => {
  return (
    <div className='whtgh__container'>
      <div className='empty__div'>
      <Feature title="What is GPT-3" para="We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by." />
      </div>
      
      <div className='gpt3__pos'>
        <h1 className='gpt3__pos__heading'>The possibilities are beyond <br />your imagination</h1>
        <p>Explore The Library</p>
      </div>

      <div className='empty-tittle'>
        <Feature title="Chatbots" para="We so opinion friends me message as delight. Whole front do of plate heard oh ought."/>
        <Feature title="Knowledgebase" para="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments."/>
        <Feature title="Education" para="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments."/>
      </div>

    </div>
  )
}

export default Whatgpt
